<template>
  <div
    v-if="show"
    :class="classObject">
    <div
      v-if="classObject.darkened"
      class="overlay__message">
      <span class="sr-only">Page Loading</span>
      <svgicon
        original
        class="overlay__icon"
        role="presentation"
        data="@iconPath/loading.svg?inline"
        width="64"
        height="64"></svgicon>
      <p
        v-if="showMessage"
        aria-hidden="true">
        Your results are loading, Please Wait...
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OverlayComponent',
  data() {
    return {
      evDarken: null,
      evMessage: null,
      showMessage: false,
      classObject: {
        darkened: false,
        overlay: true
      }
    }
  },
  computed: {
    show() {
      return this.$store.state.showOverlay
    }
  },
  watch: {
    show() {
      this.showMessage = false
      this.classObject.darkened = false
      clearTimeout(this.evDarken)
      clearTimeout(this.evMessage)
      if (this.show) {
        const overlayDelay = this.$store.state.noOverlayDelay ? 1 : 1000

        this.evDarken = setTimeout(() => {
          this.evMessage = setTimeout(() => {
            this.showMessage = true
          }, 3000)
          this.classObject.darkened = true
        }, overlayDelay)
      }
    }
  }
}
</script>
